import React from 'react';
import { IconPhoto } from '@noths/polaris-client-ribbons-design-system';

import * as S from '../PhotoPicker.styles';

interface Props {
  addMoreLabel: string;
  emptyLabel: string;
  onClick: () => void;
  previewFor: (url: string) => string | undefined;
  triggerLabel?: string;
  urls: string[];
}

function chunkPairs<T>(arr: T[]): T[][] {
  const pairs: T[][] = [];
  for (let i = 0; i < arr.length; i += 2) {
    pairs.push(arr.slice(i, i + 2));
  }
  return pairs;
}

export function PhotoPickerTrigger({
  addMoreLabel,
  emptyLabel,
  onClick,
  previewFor,
  triggerLabel,
  urls,
}: Props) {
  if (urls.length === 0) {
    return (
      <S.TriggerEmpty onClick={onClick} type="button">
        <IconPhoto height={32} width={32} />
        <span>{emptyLabel}</span>
      </S.TriggerEmpty>
    );
  }

  const rows = chunkPairs(urls);
  const lastRowFull = rows[rows.length - 1].length === 2;

  return (
    <S.TriggerFilled onClick={onClick} type="button">
      {triggerLabel && <S.TriggerLabel>{triggerLabel}</S.TriggerLabel>}
      <S.TriggerFilledGrid>
        {rows.map((pair, rowIdx) => {
          const isLastRow = rowIdx === rows.length - 1;
          return (
            <S.TriggerFilledRow key={rowIdx}>
              {pair.map((url) => (
                <img alt="" key={url} src={previewFor(url) ?? url} />
              ))}
              {isLastRow && !lastRowFull && (
                <S.TriggerAddMoreTile aria-hidden="true">
                  <IconPhoto height={32} width={32} />
                  <span>Edit photo selection &amp; order</span>
                </S.TriggerAddMoreTile>
              )}
            </S.TriggerFilledRow>
          );
        })}
        {lastRowFull && (
          <S.TriggerFilledRow>
            <S.TriggerAddMoreTile aria-hidden="true">
              <IconPhoto height={32} width={32} />
              <span>Edit photo selection &amp; order</span>
            </S.TriggerAddMoreTile>
          </S.TriggerFilledRow>
        )}
      </S.TriggerFilledGrid>
      <span style={{ display: 'none' }}>
        {urls.length} photo{urls.length === 1 ? '' : 's'} added
      </span>
      <span style={{ display: 'none' }}>{addMoreLabel}</span>
    </S.TriggerFilled>
  );
}
